import React from 'react';
import { NavLink } from 'react-router-dom';
import FullLogo from '../Photos/Fulllogo.png'; // Import the image from the Photos directory

function Navbar() {
  return (
    <nav className="navbar navbar-expand-lg navbar-light" style={{ backgroundColor: '#242424' }}>
      <div className="container-fluid">
        <a className="navbar-brand" href="/">
          <img src={FullLogo} alt="BlueRiver Manufacturing Logo" /> 
        </a>
        <div className="d-flex justify-content-center align-items-center">
          <span className="text-white fw-bold"> Contact: (402) 239-4323</span>
        </div>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNavDropdown"
          aria-controls="navbarNavDropdown"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNavDropdown">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle"
                href="#"
                id="navbarDropdownMenuLink"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Page Selection |
              </a>
              <ul className="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                <li><NavLink className="dropdown-item" to="/">Home</NavLink></li>
                <li><NavLink className="dropdown-item" to="/balefeeder">Bale Feeders</NavLink></li>
                <li><NavLink className="dropdown-item" to="/bottemlessbunks">Bottomless Bunks</NavLink></li>
                <li><NavLink className="dropdown-item" to="/FeederPanels">Feeder Panels</NavLink></li>
                
                <li><NavLink className="dropdown-item" to="/driveovergates">Driveover Gates</NavLink></li>
                <li><NavLink className="dropdown-item" to="/FreestandingPannels">Freestanding Panels</NavLink></li>
                <li><NavLink className="dropdown-item" to="/gates">Gates</NavLink></li>
                <li><NavLink className="dropdown-item" to="/continuouspannels">Continuous Panels</NavLink></li>
                <li><NavLink className="dropdown-item" to="/purposebuilt">Purpose Built</NavLink></li>
                <li><NavLink className="dropdown-item" to="/about">About</NavLink></li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;